/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetLedgerPositionsSelfStatus200,
  GetLedgerPositionsSelfStatus400,
  GetLedgerPositionsSelfStatus404,
  GetLedgerPositionsSelfStatus500,
} from '../types/GetLedgerPositionsSelf'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getLedgerPositionsSelf } from '../clients/getLedgerPositionsSelf'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getLedgerPositionsSelfQueryKey = () => [{ url: '/v1/ledger/positions/self' }] as const

type GetLedgerPositionsSelfQueryKey = ReturnType<typeof getLedgerPositionsSelfQueryKey>

export function getLedgerPositionsSelfQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getLedgerPositionsSelfQueryKey()
  return queryOptions<
    GetLedgerPositionsSelfStatus200,
    ResponseErrorConfig<
      | GetLedgerPositionsSelfStatus400
      | GetLedgerPositionsSelfStatus404
      | GetLedgerPositionsSelfStatus500
    >,
    GetLedgerPositionsSelfStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getLedgerPositionsSelf({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get your own positions
 * {@link /v1/ledger/positions/self}
 */
export function useGetLedgerPositionsSelf<
  TData = GetLedgerPositionsSelfStatus200,
  TQueryData = GetLedgerPositionsSelfStatus200,
  TQueryKey extends QueryKey = GetLedgerPositionsSelfQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetLedgerPositionsSelfStatus200,
        ResponseErrorConfig<
          | GetLedgerPositionsSelfStatus400
          | GetLedgerPositionsSelfStatus404
          | GetLedgerPositionsSelfStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getLedgerPositionsSelfQueryKey()

  const queryResult = useQuery(
    {
      ...getLedgerPositionsSelfQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetLedgerPositionsSelfStatus400
      | GetLedgerPositionsSelfStatus404
      | GetLedgerPositionsSelfStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
